(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      const spaceBetweenMobile = swiperOptions.spaceBetweenMobile || 10;
      const spaceBetweenDesktop = swiperOptions.spaceBetweenDesktop || 20;
      /* console.log(swiperOptions); */

      this.sliderOptions = {
        slidesPerView: 1,
        spaceBetween: spaceBetweenMobile,
        loop: true,
        navigation: {
          nextEl: this.parent.querySelector('.swiper-button--next'),
          prevEl: this.parent.querySelector('.swiper-button--prev')
        },
        // updated by JS
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: spaceBetweenDesktop
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: spaceBetweenDesktop
          }
        }
      };
    }

    initSlider() {
      super.initSlider();
      this.parentElement.classList.remove('hidden');
    }
  }

  customElements.define(
    'complementary-products',
    ComplementaryProducts
  );
})();
